import { AdPlacementsGroupType } from '@bingads-webui-campaign-react/ad-placement-consts';

import { imageExtensionTemplates } from './image-extension/index';
import { msanImageAdTemplates } from './msan-image-ad';
import { perfMaxTemplates } from './perf-max-ad';
import { searchImageAdTemplates } from './search-image-ad';
import { streamlinedSignupTemplates } from './streamlined-signup';
import { adLibraryTemplates } from './ad-library';
import { msanBoostImageAdTemplates } from './msan-boost-ad';
import { appImageAdTemplates, appImageAdStartTemplates } from './app-ad';
import { responsiveSearchAdTemplates } from './responsive-search-ad';
import { dynamicSearchAdTemplates } from './dynamic-search-ad';

export const GroupTypeTemplatesMapping = {
  [AdPlacementsGroupType.imageExtension]: imageExtensionTemplates,
  [AdPlacementsGroupType.msanImageAd]: msanImageAdTemplates,
  [AdPlacementsGroupType.perfMax]: perfMaxTemplates,
  [AdPlacementsGroupType.searchImageAd]: searchImageAdTemplates,
  [AdPlacementsGroupType.streamlinedSignup]: streamlinedSignupTemplates,
  [AdPlacementsGroupType.adLibrary]: adLibraryTemplates,
  [AdPlacementsGroupType.msanBoostImageAd]: msanBoostImageAdTemplates,
  [AdPlacementsGroupType.appAd]: appImageAdTemplates,
  [AdPlacementsGroupType.appAdStart]: appImageAdStartTemplates,
  [AdPlacementsGroupType.responsiveSearchAd]: responsiveSearchAdTemplates,
  [AdPlacementsGroupType.dynamicSearchAd]: dynamicSearchAdTemplates,
};
